import 'twin.macro'

import { Ring } from '@uiball/loaders'
import CashStackIcon from 'assets/icons/cash-stack-icon.svg?component'
import CloseIcon from 'assets/icons/close-icon.svg?component'
import CheckIcon from 'assets/icons/step-done-check.svg?component'
import ConditionBlock from 'components/UI/Blocks/ConditionBlock'
import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Button from 'components/UI/Buttons/Button'
import ContainerWithSteps from 'components/UI/Container/ContainerWithSteps'
import Typography from 'components/UI/Typography'
import { useAppSelector } from 'hooks'
import { useMemo } from 'react'
import { useLazyGetApplicationStatusQuery } from 'redux/api'
import { useGetBankTransferDetailsQuery } from 'redux/api/creditApi'
import { useStartPayboxComissionPaymentMutation } from 'redux/api/pledgeApi'
import { getStatusSelector } from 'redux/store/slices/statusSlice'
import { getActiveCreditApplication, getCurrentFlowId } from 'redux/store/slices/userSlice'
import { getNotificationsSelector } from 'redux/store/slices/wsSlice'
import { FLOW_STEPS } from 'share/types'
import tw from 'twin.macro'
import { getWsStepStatuses } from 'utils'
import { useTranslation } from 'react-i18next'

// TODO: Check current or next step and then show component
// If PLEDGE_FEE show guarantee payment component
// Else if COMMISION_FEE show commision payment component
const Payment = () => {
  // Selectors
  const { id: creditID } = useAppSelector(getActiveCreditApplication)
  const currentFlowId = useAppSelector(getCurrentFlowId)
  const statusData = useAppSelector(getStatusSelector)
  const { PAYBOX_COMISSION_FEE_PAYMENT } = useAppSelector(getNotificationsSelector)

  // Queries
  const { data: transferInfo } = useGetBankTransferDetailsQuery(creditID as string)

  // Mutations
  const [startComissionPayment] = useStartPayboxComissionPaymentMutation()
  const [fetchStatus] = useLazyGetApplicationStatusQuery()

  // Computed values
  const isBtnDisabled =
    getWsStepStatuses(PAYBOX_COMISSION_FEE_PAYMENT) === 'IN_PROGRESS' ||
    (statusData.current_step?.step === FLOW_STEPS.PAYBOX_COMISSION_FEE_PAYMENT &&
      statusData.current_step.status === 'IN_PROGRESS')

  const paymentLink = useMemo(() => {
    const data = statusData.current_step?.data as {
      payment_url: string
    }
    return data?.payment_url
  }, [statusData.current_step])

  // Handlers
  const handlePayboxCommisionPayment = async () => {
    try {
      const data = await startComissionPayment(currentFlowId as string).unwrap()
      await fetchStatus(currentFlowId as string)
      console.log(data)
    } catch (err) {
      console.log(err)
    }
  }

  const { t } = useTranslation()

  return (
    <ContainerWithSteps>
      <div tw='flex flex-col mt-3 sm:mt-0'>
        <InfoBlock twStyle={tw`px-0 pb-0`}>
          <div tw='px-5 pb-5'>
            <Typography weight='bold'>Оплата комиссии</Typography>
            <Typography variant='subbody' text twStyle={tw`text-grey-dark mt-2`}>
              {t('pay-estimation')}{' '}
              <Typography as='span' variant='subbody' weight='bold' twStyle={tw`text-primary-middle`}>
                {transferInfo?.amount} ₸
              </Typography>
            </Typography>
          </div>
          <div tw='grid grid-cols-1 sm:grid-cols-2 border-t border-stroke'>
            <ConditionBlock
              caption='Сумма'
              body={`${transferInfo?.amount} ₸`}
              icon={<CashStackIcon />}
              twStyle={tw`border-b sm:border-b-0 sm:border-r border-stroke`}
            />
          </div>
        </InfoBlock>
        {getWsStepStatuses(PAYBOX_COMISSION_FEE_PAYMENT) === 'IN_PROGRESS' ||
        (statusData.current_step?.step === FLOW_STEPS.PAYBOX_COMISSION_FEE_PAYMENT &&
          statusData.current_step.status === 'IN_PROGRESS') ? (
          <InfoBlock twStyle={tw`flex items-center mt-3`}>
            <div tw='space-y-1'>
              <Typography weight='bold'>{t('payment-check')}</Typography>
              {paymentLink && (
                <a href={paymentLink} tw='text-primary underline block'>
                  <Typography variant='caption' weight='bold'>
                    {t('back-to-pay')}
                  </Typography>
                </a>
              )}
            </div>
            <span tw='ml-auto flex-shrink-0'>
              <Ring size={24} color='var(--primary-color)' />
            </span>
          </InfoBlock>
        ) : getWsStepStatuses(PAYBOX_COMISSION_FEE_PAYMENT) === 'DONE' ||
          (statusData.current_step?.step === FLOW_STEPS.PAYBOX_COMISSION_FEE_PAYMENT &&
            statusData.current_step.status === 'DONE') ? (
          <InfoBlock twStyle={tw`flex items-center mt-3`}>
            <Typography weight='bold'>Оплата произведена</Typography>
            <CheckIcon tw='flex-shrink-0 ml-auto w-5 h-5' />
          </InfoBlock>
        ) : getWsStepStatuses(PAYBOX_COMISSION_FEE_PAYMENT) === 'FAILED' ||
          (statusData.current_step?.step === FLOW_STEPS.PAYBOX_COMISSION_FEE_PAYMENT &&
            statusData.current_step.status === 'FAILED') ? (
          <InfoBlock twStyle={tw`flex items-center mt-3`}>
            <Typography weight='bold'>Не получилось оплатить платеж</Typography>
            <CloseIcon tw='text-primary-middle ml-auto w-4 h-4' />
          </InfoBlock>
        ) : null}
        <Button
          variant='secondary'
          twStyle={tw`mt-5  sm:max-w-[306px] self-end`}
          disabled={isBtnDisabled}
          onClick={handlePayboxCommisionPayment}
        >
          {t('pay')}
        </Button>
      </div>
    </ContainerWithSteps>
  )
}

export default Payment
